/**
 * Return the fontId based on the provided font family
 */
export function getFontId(fontFamily: string): string {
  return fontFamily.replace(/\s+/g, '-').toLowerCase();
}
